import type { StepData } from "./types";

/** `data-tour="name"` selector. */
export const el = (name: string) => `[data-tour="${name}"]`;

export const exists = (selector: string) => () => !!document.querySelector(selector);

export const click = (selector: string) => () =>
  (document.querySelector(selector) as HTMLElement | null)?.click();

/** The first laid-out match (skips an element rendered twice — hidden mobile
 *  card + visible desktop row — which would otherwise pin the popover to the
 *  top-left corner). */
export const visible = (selector: string) => (): Element | undefined =>
  Array.from(document.querySelectorAll<HTMLElement>(selector)).find(
    (node) => node.offsetParent !== null,
  ) as Element | undefined;

/** Scroll `elm` into view inside any scrolling ancestor before the highlight.
 *  With `block` set, always scroll to that alignment; otherwise only when a
 *  container clips it. */
export function revealInScrollers(elm: Element, block?: ScrollLogicalPosition) {
  if (block) {
    elm.scrollIntoView({ block, inline: "nearest", behavior: "auto" });
    return;
  }
  const rect = elm.getBoundingClientRect();
  if (rect.top < 0 || rect.bottom > window.innerHeight) {
    elm.scrollIntoView({ block: "center", inline: "nearest", behavior: "auto" });
  }
}

/** For a step that ends with the user clicking the highlighted element: Next
 *  never skips ahead, it repeats the instruction. Spread into the step's data. */
export function clickToContinue(
  text: string,
  observe?: "element" | "document",
): Pick<StepData, "live" | "nextHidden"> {
  return {
    live: { advanceWhen: () => false, nudge: { text }, ...(observe ? { observe } : {}) },
    nextHidden: true,
  };
}
